import { Observable, Subscriber } from 'rxjs';
import { GetTCRequest } from '../../models/GetTCRequest';
import { UpdateTCRequest } from '../../models/UpdateTCRequest';
import { MposWebPortalApi } from '../api/MposWebPortalApi';
import { ConfigProvider } from '../configuration/ConfigProvider';
import { sessionStorageInstance } from '../storage/Storage';

export enum TCStatusAfterUpdate {
    NOTHING_TO_UPDATE, UPDATE_SUCCESS, UPDATE_FAILED
}

export class TermsAndConditionsManager {
    private static instance: TermsAndConditionsManager;
    private static TC_DATA_KEY = "tcData";
    private config = ConfigProvider.getInstance().getConfiguration();

    public static getInstance(): TermsAndConditionsManager {
        if(!TermsAndConditionsManager.instance){
            TermsAndConditionsManager.instance = new TermsAndConditionsManager();
        }
        return TermsAndConditionsManager.instance;
    }

    public showTCAfterChangePassword(): Observable<boolean>{
        console.log("[TermsAndConditionsManager] Show T&C?");
        return new Observable((subscriber: Subscriber<boolean>) => {
            // @ts-ignore
            let tcVersionFromConfig = this.config.tcVersion;
            let request = new GetTCRequest(tcVersionFromConfig);
            MposWebPortalApi.getInstance().getTCStatus(request).subscribe((response) => {
                console.log("[TermsAndConditionsManager] Show T&C? " + !response.accepted);
                if(!response.accepted){
                    console.log("[TermsAndConditionsManager] saving T&C Data...");
                    let tcData = {
                        versionToAccept: response.tcVersion,
                        accepted: response.accepted
                    }
                    sessionStorageInstance.setData(TermsAndConditionsManager.TC_DATA_KEY, tcData);
                }
                
                subscriber.next(!response.accepted);
            }, () => {
                console.log("[TermsAndConditionsManager] Error when trying to retrieve T&C status");
                subscriber.next(false);
            })
        });
    }

    public showTermsAndCondition(): Promise<boolean>{
        console.log("[TermsAndConditionsManager] Show T&C? with promise...");
        return new Promise((resolve) => {
            // @ts-ignore
            let tcVersionFromConfig = this.config.tcVersion;
            let request = new GetTCRequest(tcVersionFromConfig);
            MposWebPortalApi.getInstance().getTCStatus(request).subscribe((response) => {
                console.log("[TermsAndConditionsManager] Show T&C? " + !response.accepted);
                if(!response.accepted){
                    console.log("[TermsAndConditionsManager] saving T&C Data...");
                    let tcData = {
                        versionToAccept: response.tcVersion,
                        accepted: response.accepted
                    }
                    sessionStorageInstance.setData(TermsAndConditionsManager.TC_DATA_KEY, tcData);
                }
                
                return resolve(!response.accepted);
            }, () => {
                console.log("[TermsAndConditionsManager] Error when trying to retrieve T&C status");
                return resolve(false);
            })
        });
    }

    public updateTCStatus(): Observable<TCStatusAfterUpdate>{
        console.log("[TermsAndConditionsManager] Update TC called! retrieving data...");
        return new Observable((subscriber: Subscriber<TCStatusAfterUpdate>) => {
            let data = sessionStorageInstance.getData(TermsAndConditionsManager.TC_DATA_KEY);
            if(data !== null){
                let tcData = JSON.parse(data);
                if(!tcData.accepted){
                    console.log("[TermsAndConditionsManager] Prepare request!");
                    let timestamp = new Date().getTime().toString();
                    let updateTCRequest = new UpdateTCRequest(true, tcData.versionToAccept, timestamp);
                    MposWebPortalApi.getInstance().updateTCStatus(updateTCRequest).subscribe((response) => {
                        if(response){
                            console.log("[TermsAndConditionsManager] TC update success!");
                            sessionStorageInstance.removeData(TermsAndConditionsManager.TC_DATA_KEY);
                            subscriber.next(TCStatusAfterUpdate.UPDATE_SUCCESS);
                        } else {
                            console.log("[TermsAndConditionsManager] TC update failed!");
                            sessionStorageInstance.removeData(TermsAndConditionsManager.TC_DATA_KEY);
                            subscriber.next(TCStatusAfterUpdate.UPDATE_FAILED);
                        }
                    }, () => {
                        console.log("[TermsAndConditionsManager] TC update error!");
                        sessionStorageInstance.removeData(TermsAndConditionsManager.TC_DATA_KEY);
                        subscriber.next(TCStatusAfterUpdate.UPDATE_FAILED);
                    })
                } else {
                    console.log("[TermsAndConditionsManager] TC already accepted, nothing to update!");
                    subscriber.next(TCStatusAfterUpdate.NOTHING_TO_UPDATE);
                }
            } else {
                console.log("[TermsAndConditionsManager] Null data, nothing to update!");
                subscriber.next(TCStatusAfterUpdate.NOTHING_TO_UPDATE);
            }
        });
    }
}